import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as moment from 'moment';
import { AuthService } from 'src/app/services/auth.service';

@Injectable({
  providedIn: 'root'
})


export class SettingsService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': '',
    })
  };


  myDate = new Date()
  date: any;
  private apiUrl: string;
  private apiUrlStud: string;
  constructor(private http: HttpClient, private _authService: AuthService) {
    const BASE_API_URL = environment.ApiConfig.settings;
    const BASE_API_URL_Student = environment.ApiConfig.student;

    this.apiUrl = `${BASE_API_URL}/settings`;
    this.apiUrlStud = `${BASE_API_URL_Student}/student`;


    // this._authService.getUserDetails().then(data => {
    //   this.httpOptions = {
    //     headers: new HttpHeaders({
    //       'Content-Type': 'application/json',
    //       'Authorization': data.user.signInUserSession.idToken.jwtToken,
    //     })

    //   };
    //   //this.http.options(this.httpOptions);


    // })




  }


  getCurrentDate() {
    return moment().format("YYYY-MM-DD HH:mm:ss");

  }
  getHobbies() {
    return this.http.get(`${this.apiUrl}/hobbies`, this.httpOptions);
  }
  getLanguages() {
    return this.http.get(`${this.apiUrl}/languages`);
  }

  getEcas() {
    return this.http.get(`${this.apiUrl}/extra-curricular-activities`);
  }

  getAspirations() {
    return this.http.get(`${this.apiUrl}/aspirations`, this.httpOptions);
  }

  getCompetitiveExams() {
    return this.http.get(`${this.apiUrl}/competitive-exams`);
  }

  getAchievementLevels() {
    return this.http.get(`${this.apiUrl}/achievements/level`);
  }

  getAchievementFields() {
    return this.http.get(`${this.apiUrl}/achievements/fields`, this.httpOptions);

  }

  getSchoolList() {
    return this.http.get(`${this.apiUrl}/education/schools`);
  }

  getCollegesList() {
    return this.http.get(`${this.apiUrl}/education/colleges`);
  }

  getCollegesListOnSearch(searchKey, classId) {
    if (searchKey == 1) {
      // return this.http.get(`${this.apiUrl}/education/colleges`);
      return this.http.get(`${this.apiUrlStud}/profile/education?class_id=${classId}&type=schools`);


    } else {
      return this.http.get(`${this.apiUrlStud}/profile/education?class_id=${classId}&type=schools&q=${searchKey}`);

      //  return this.http.get(`${this.apiUrl}/education/colleges?q=${searchKey}`);

    }
  }

  getUniversitiesList() {
    return this.http.get(`${this.apiUrl}/education/universities`);
  }

  getBoardsList() {
    return this.http.get(`${this.apiUrl}/education/boards`);
  }

  updateCareerCount(uuid, career_id, cluster_id) {
    let patchData = {
      uuid: uuid,
      id: career_id,
      cluster_id: cluster_id
    }
    return this.http.patch(`${this.apiUrl}/dashboard/users/student/explore`, patchData);
  }
  updateCluster(uuid, cluster_id) {
    let patchData = {
      uuid: uuid,
      cluster_id: cluster_id
    }
    return this.http.patch(`${this.apiUrl}/dashboard/users/student/explore`, patchData);
  }
  getCluster(uuid) {
    return this.http.get(`${this.apiUrl}/dashboard/users/student/explore?uuid=${uuid}`);
  }

  getCareerCount(uuid) {
    return this.http.get(`${this.apiUrl}/dashboard/users/student/explore?uuid=${uuid}`);
  }


  // for family profile
  getEducationForFamily() {
    return this.http.get(`${this.apiUrl}/parent/education`);
  }

  getOccupationForFamily() {
    return this.http.get(`${this.apiUrl}/occupations`);
  }


  getStudentEducationClass() {
    return this.http.get(`${this.apiUrlStud}/profile/education?type=classes`, this.httpOptions);
  }

  getStudentEducationStream(classId) {
    return this.http.get(`${this.apiUrlStud}/profile/education?class_id=${classId}&type=streams`);
  }

  getStudentEducationSubject(classid, streamId) {

    return this.http.get(`${this.apiUrlStud}/profile/education?class_id=${classid}&stream_course_id=${streamId}&type=subjects`);
  }

  getSchoolListForEducation(classId) {
    return this.http.get(`${this.apiUrlStud}/profile/education?class_id=${classId}&type=schools`);
  }

  getBoardListforEducation(classId) {
    return this.http.get(`${this.apiUrlStud}/profile/education?class_id=${classId}&type=boards`);
  }





  // for education post API'S


  addExamDetails(userAttributes) {
    userAttributes.created_at = this.getCurrentDate();
    userAttributes.updated_at = this.getCurrentDate();
    return this.http.post(`${this.apiUrl}/competitive-exams`, userAttributes);
  }

  addSchoolDetails(school) {
    school.created_at = this.getCurrentDate();
    school.updated_at = this.getCurrentDate();
    return this.http.post(`${this.apiUrl}/education/schools`, school);
  }


  addcollegesDetails(colleges) {
    colleges.created_at = this.getCurrentDate();
    colleges.updated_at = this.getCurrentDate();
    return this.http.post(`${this.apiUrl}/education/colleges`, colleges);
  }

  addBoardDetails(board) {
    board.created_at = this.getCurrentDate();
    board.updated_at = this.getCurrentDate();
    return this.http.post(`${this.apiUrl}/education/boards`, board);
  }

  adduniversitiesDetails(universities) {
    universities.created_at = this.getCurrentDate();
    universities.updated_at = this.getCurrentDate();
    return this.http.post(`${this.apiUrl}/education/universities`, universities);
  }


  // for family post api

  addOccupationsDetails(userAttributes) {
    userAttributes.created_at = this.getCurrentDate();
    userAttributes.updated_at = this.getCurrentDate();
    console.log('userAttributes----', userAttributes)

    return this.http.post(`${this.apiUrl}/occupations`, userAttributes);
  }

  addParentEducationDetails(userAttributes) {
    userAttributes.created_at = this.getCurrentDate();
    userAttributes.updated_at = this.getCurrentDate();
    return this.http.post(`${this.apiUrl}/parent/education`, userAttributes);
  }

  addAchievementsFields(userAttributes) {
    userAttributes.created_at = this.getCurrentDate();
    userAttributes.updated_at = this.getCurrentDate();
    return this.http.post(`${this.apiUrl}/achievements/fields`, userAttributes);
  }

  addAchievementsLeavel(userAttributes) {
    userAttributes.created_at = this.getCurrentDate();
    userAttributes.updated_at = this.getCurrentDate();
    return this.http.post(`${this.apiUrl}/achievements/level`, userAttributes);
  }

  addLanguages(userAttributes) {
    userAttributes.created_at = this.getCurrentDate();
    userAttributes.updated_at = this.getCurrentDate();
    return this.http.post(`${this.apiUrl}/languages`, userAttributes);
  }


  // for education PACH API'S

  updateCollegeDetails(uuid, updatedData) {
    updatedData.updated_at = this.getCurrentDate();
    return this.http.patch(`${this.apiUrl}/education/colleges/${uuid}`, updatedData);
  }

  updateSchoolDetails(uuid, updatedData) {
    updatedData.updated_at = this.getCurrentDate();
    return this.http.patch(`${this.apiUrl}/education/schools/${uuid}`, updatedData);
  }

  updateCompetitiveExamsDetails(uuid, updatedData) {
    updatedData.updated_at = this.getCurrentDate();
    return this.http.patch(`${this.apiUrl}/competitive-exams/${uuid}`, updatedData);
  }

  updateParentEducationDetails(uuid, updatedData) {
    updatedData.updated_at = this.getCurrentDate();
    return this.http.patch(`${this.apiUrl}/parent/education/${uuid}`, updatedData);
  }

  updateUniversitiesDetails(uuid, updatedData) {
    updatedData.updated_at = this.getCurrentDate();
    return this.http.patch(`${this.apiUrl}/education/universities/${uuid}`, updatedData);
  }

  updateBoardDetails(uuid, updatedData) {
    updatedData.updated_at = this.getCurrentDate();
    return this.http.patch(`${this.apiUrl}/education/boards/${uuid}`, updatedData);
  }

  updateOccupationsDetails(uuid, updatedData) {
    updatedData.updated_at = this.getCurrentDate();
    console.log('updatedData----', updatedData)

    return this.http.patch(`${this.apiUrl}/occupations/${uuid}`, updatedData);
  }

  updateAchievementsFields(uuid, updatedData) {
    updatedData.updated_at = this.getCurrentDate();
    return this.http.patch(`${this.apiUrl}/achievements/fields/${uuid}`, updatedData);
  }

  updateAchievementsLevel(uuid, updatedData) {
    updatedData.updated_at = this.getCurrentDate();
    return this.http.patch(`${this.apiUrl}/achievements/level/${uuid}`, updatedData);
  }

  updateLanguages(uuid, updatedData) {
    updatedData.updated_at = this.getCurrentDate();
    return this.http.patch(`${this.apiUrl}/languages/${uuid}`, updatedData);
  }

  deleteCollegeDetails(uuid) {
    return this.http.delete(`${this.apiUrl}/education/colleges/${uuid}`);
  }

  deleteLanguages(uuid) {
    return this.http.delete(`${this.apiUrl}/languages/${uuid}`);
  }

  deleteSchoolDetails(uuid) {
    return this.http.delete(`${this.apiUrl}/education/schools/${uuid}`);
  }



  deleteAchievementsFields(uuid) {
    return this.http.delete(`${this.apiUrl}/achievements/fields/${uuid}`);
  }

  deleteAchievementsLevel(uuid) {
    return this.http.delete(`${this.apiUrl}/achievements/level/${uuid}`);
  }
  deleteOccupationsDetails(uuid) {
    return this.http.delete(`${this.apiUrl}/occupations/${uuid}`);
  }

  deleteCompetitiveExamsDetails(uuid) {
    return this.http.delete(`${this.apiUrl}/competitive-exams/${uuid}`);
  }

  deleteUniversitiesDetails(uuid) {
    return this.http.delete(`${this.apiUrl}/education/universities/${uuid}`);
  }

  deleteBoardDetails(uuid) {
    return this.http.delete(`${this.apiUrl}/education/boards/${uuid}`);
  }

  deleteParentEducationDetails(uuid) {
    return this.http.delete(`${this.apiUrl}/parent/education/${uuid}`);
  }



}
